export default __webpack_public_path__ + "static/images/welcome-inset.bbe47e75.png";